import SSOProcoreButton from './SSOProcoreButton';
import './SSOProcoreButton.scss';

export default SSOProcoreButton;
